module.exports = __webpack_public_path__ + "static/media/038.2e7c68fa.jpg";